import React, { forwardRef, useEffect } from 'react'
import className from 'classnames/bind'

import style from './MyhouseNotifyTabMenu.module.scss'

import ArrowLeft8x14 from '@Ui/images/myhouse/ArrowLeft8x14.svg'
import ArrowRight8x14 from '@Ui/images/myhouse/ArrowRight8x14.svg'

const cx = className.bind(style)

type Props = {
  buttonRef?: any
  houses?: any
  handleHouseClick?: any
  selectHouseNo?: any
}

type ButtonForwardRefType = {
  index?: any
  buttonRef?: any
  house?: any
  handleHouseClick?: any
  selectHouseNo?: any
}

const ButtonForwardRef: React.FC<ButtonForwardRefType> = forwardRef(({ index, buttonRef, house, handleHouseClick, selectHouseNo }: ButtonForwardRefType, ref: any) => {
  const focusIndex = selectHouseNo === house.houseNo ? index : ''
  useEffect(() => {
    if (!!focusIndex) {
      buttonRef.current[focusIndex].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'center' })
    }
  }, [focusIndex])
  return (
    <>
      <button
        key={index}
        ref={(el) => (buttonRef.current[index] = el)}
        type="button"
        role="tab"
        className={cx('myhouse_tab')}
        aria-selected={selectHouseNo === house.houseNo}
        onClick={(e) => {
          handleHouseClick(e, house.houseNo)
        }}
      >
        <strong className={cx('myhouse_tab_title')}>{house.houseLabel}</strong>
        <span className={cx('myhouse_tab_detail')}>{house.additionalInfo}</span>
      </button>
    </>
  )
})
ButtonForwardRef.displayName = 'ButtonForwardRef'

const MyhouseNotifyTabMenu: React.FC<Props> = ({ buttonRef, houses, handleHouseClick, selectHouseNo }: Props) => {
  return (
    <>
      <div className={cx('myhouse_notify_tab')}>
        <div className={cx('myhouse_tab_menu')} role="tablist">
          {houses &&
            houses.map((house: any, index: any) => (
              <ButtonForwardRef key={index} index={index} buttonRef={buttonRef} house={house} handleHouseClick={handleHouseClick} selectHouseNo={selectHouseNo} />
            ))}
        </div>
        {/* 버튼 미노출 시 type_none 클래스 추가 */}
        <button type="button" className={cx('myhouse_scroll_button', 'type_left')} aria-label="이전">
          <ArrowLeft8x14 />
        </button>
        <button type="button" className={cx('myhouse_scroll_button', 'type_right')} aria-label="다음">
          <ArrowRight8x14 />
        </button>
      </div>
    </>
  )
}

export default MyhouseNotifyTabMenu
